import { ThemeConfig } from 'antd'

export const ThemeCommon: ThemeConfig = {
  token: {
    motion: false,
    fontFamily: '"IBM Plex Sans", sans-serif',
    borderRadius: 0,
  },
  components: {},
}
